<template>
  <div class="page pyzz">
    <BottomNav
      :page="page"
      class="top-nav"
      :items="tabs"
      :active="currentTab"
      :btnclass="lngBtn"
      @changeNav="changeTab"
    ></BottomNav>
    
    <div class="pyzz-ctx">
      <div class="pyzz-swiper">
        <swiper :options="swiperOption" ref="pyzzSwiper">
          <swiper-slide v-for="(pic, index) in swiperPics" :key="index">
            <img :src="pic">
          </swiper-slide>
        </swiper>
        <div class="swiper-pagination"></div>
      </div>
      
      <m-textarea :class="contentClass">
        <div :class="ruTxt" v-html="content"></div>
      </m-textarea>

      <div class="pyzz-video" @click="playvideo">
        <img src="img/pyzz/pyzz-play.png">
      </div>
    </div>

    <VideoPlay
      v-if="videoPlayer"
      :info="videoInfo"
      @closePlayer="videoPlayer = false"
    ></VideoPlay>
  </div>
</template>

<script>
import { mapState, mapGetters, mapActions } from "vuex";

import BottomNav from "@/components/BottomNav.vue";
import TextArea from "@/components/TextArea.vue";
import VideoPlay from "@/components/VideoPlay.vue";

export default {
  components: {
    BottomNav,
    "m-textarea": TextArea,
    VideoPlay
  },
  data() {
    return {
      page: "pyzz",
      currentTab: 0,
      curretTabName: "zhipi",
      swiperOption: {
        slidesPerView: "auto",
        spaceBetween: 6,
        pagination: {
          el: ".swiper-pagination"
        }
      },
      videoInfo: {
        url:
          "http://shadow.caa.edu.cn/py/pyzz.mp4",
        title: this.$t("page.pyzz-video")
      },
      videoPlayer: false
    };
  },
  computed: {
    ...mapState({
      tabs: state => state.tabs.pyzz,
      pyzz: "pyzz",
      locale: "locale"
    }),
    ...mapGetters(["lngClass"]),
    contentClass() {
      return `${this.page}-tabs`;
    },
    content() {
      const tabData = this.pyzz[this.curretTabName];
      return tabData ? tabData.content : "";
    },
    swiperPics() {
      return this.tabs[this.currentTab].swiperPics;
    },
    lngBtn() {
      return this.lngClass ? "pyzz-nav lng-span" : "pyzz-nav";
    },
    ruTxt() {
      return this.locale === "ru" ? "ru-text" : "";
    }
  },
  mounted() {
    this.getContent({
      page: this.page,
      tab: "zhipi"
    });
  },
  methods: {
    ...mapActions(["getContent"]),
    async changeTab(activeNum) {
      const tabName = this.tabs[activeNum].name;
      this.getContent({
        page: this.page,
        tab: tabName
      }).then(() => {
        this.currentTab = activeNum;
        this.curretTabName = tabName;
        this.swiperUpdate();
      });
    },
    swiperUpdate() {
      const swiper = this.$refs.pyzzSwiper.swiper;
      swiper.update();
      swiper.updateSlides();
      swiper.pagination.update();
      swiper.slideTo(0);
    },
    playvideo() {
      this.videoPlayer = true;
    }
  }
};
</script>

<style lang="scss">
@import "../assets/base";
@import "../assets/swiper.min.css";
.pyzz {
  .top-nav {
    position: relative;
    justify-content: start;
    overflow-x: auto;
    width: auto;
    bottom: auto;
    left: 0;
    transform: none;
    background-color: rgba(255, 255, 255, 0.7);
  }
}

.pyzz-nav {
  margin: 0;
  .icon {
    display: none;
  }
  span {
    display: inline-block;
    padding: 1rem 0;
    line-height: 1;
  }
  &.lng-span {
    span {
      padding: 1rem;
      font-weight: 500;
    }
  }
}

.pyzz-ctx {
  position: relative;
}

.pyzz-swiper {
  background-color: #e1d3b0;

  .swiper-slide {
    display: inline-block;
    width: auto;
    height: 30vh;
    background-color: $secondary;

    @include img-fluid-height;
  }

  .swiper-pagination {
    position: relative;
    line-height: 1;
  }

  .swiper-pagination-bullet {
    margin: 8px;
    background: $primary;
    opacity: 0.6;
    transition: all 0.2s;
  }

  .swiper-pagination-bullet-active {
    width: 24px;
    border-radius: 4px;
    opacity: 1;
  }
}

.pyzz-tabs {
  position: relative;
  height: 32vh;
  margin: 1rem;

  .text-main {
    padding-right: 1rem;
    font-size: 0.875rem;

    @include title-h3(0.875rem);

    .ru-text {
      h3 {
        font-weight: 500;
      }
    }
  }
}

.pyzz-video {
  position: absolute;
  margin-top: 0.5rem;
  width: 7.5rem;
  height: 2.95rem;
  @include center-x;
  @include img-fluid;
}
</style>
